import { AssessmentIcon, DashboardAssessmentIcon, DashboardIcon, PatientAddIcon, ClientIcon, ResultIconTrendingUp, ScheduledTodayIcon, SettingsIcon, FolderIcon, CircleTickIcon, RupeeIcon, ClockIcon, DollarIcon, CircleAlertIcon, BuildingIcon, AwardIcon } from "../icons/Icons";

export const assessorMenus = [
    { name: 'Dashboard', redirectTo: '/home', startsWithText: "/home", icon: DashboardIcon },
    { name: 'Sites', redirectTo: '/sites', startsWithText: "/sites", icon: BuildingIcon },
    { name: 'Clients', redirectTo: '/clients', startsWithText: "/clients", icon: ClientIcon },
    { name: 'Projects', redirectTo: '/projects', startsWithText: "/projects", icon: AssessmentIcon },
    { name: 'Plans & Invoices', redirectTo: '/plans', startsWithText: "/plans", icon: AwardIcon },
    // { name: 'Invoices', redirectTo: '/invoices', startsWithText: "/invoices", icon: ScheduledTodayIcon },
    { name: 'Settings', redirectTo: '/settings', startsWithText: "/settings", icon: SettingsIcon },
];

export const assesseMenus = [
    { name: 'Dashboard', redirectTo: '/home', imgname: "dashboard", includes: "home", icon: DashboardIcon },
    // { name: 'Assessments', redirectTo: '/take-assessments', imgname: "folder", includes: "assessments", icon: AssessmentIcon },
     { name: 'Sites', redirectTo: '/sites', startsWithText: "/sites", icon: BuildingIcon },
    { name: 'Clients', redirectTo: '/clients', startsWithText: "/clients", icon: ClientIcon },
    { name: 'Projects', redirectTo: '/projects', startsWithText: "/projects", icon: AssessmentIcon },
    { name: 'Plans & Invoices', redirectTo: '/plans', startsWithText: "/plans", icon: AwardIcon },
    // { name: 'Invoices', redirectTo: '/invoices', startsWithText: "/invoices", icon: ScheduledTodayIcon },
    { name: 'Settings', redirectTo: '/settings', startsWithText: "/settings", icon: SettingsIcon },
];

export const DASHBOARD_METRICS = [
    { label: 'Total Projects', key: 'totalprojects', value: 0, icon: FolderIcon, description: "All time", className: 'summary-icon-purple' },
    { label: 'Completed', key: 'completed', value: 0, icon: CircleTickIcon, description: "With full analysis", className: 'summary-icon-green' },
    { label: 'Total Estimated Value', key: 'totalestimatedvalue', value: 0, icon: RupeeIcon, description: "In INR", className: 'summary-icon-orange' },
];

export const DASHBOARD_QUICK_ACTIONS = [
    { label: 'Register Patient', icon: PatientAddIcon, redirectTo: '/patients/create', className: 'patient-add-icon' },
    { label: 'Create Assessment', icon: DashboardAssessmentIcon, redirectTo: '/assessments/create', className: 'assessment-add-icon' },
    { label: 'View Results', icon: ResultIconTrendingUp, redirectTo: '/results', className: 'results-icon' }
];

export const ASSIGNMENT_METRICS = [
    { label: 'Total', key: 'total', value: 0, className: '' },
    { label: 'Pending', key: 'notstarted', value: 0, className: 'text-warning' },
    { label: 'In Progress', key: 'inprogress', value: 0, className: 'text-info' },
    { label: 'Completed', key: 'completed', value: 0, className: 'text-success' },
    { label: 'Overdue', key: 'expired', value: 0, className: 'text-danger' }
];

export const CLIENT_METRICS = [
    { label: 'Total Clients', key: 'totalclients', value: 0, icon: ClientIcon, description: "" },
    { label: 'Total Projects', key: 'totalprojects', value: 0, icon: FolderIcon, description: "" },
    { label: 'Total Value', key: 'totalvalue', value: 0, icon: RupeeIcon, description: "" },
];

export const PROJECT_METRICS = [
    { label: 'Total Projects', key: 'totalprojects', value: 0, icon: FolderIcon, className: 'total-icon' },
    { label: 'Inprogress', key: 'inprogress', value: 0, icon: CircleTickIcon, className: 'approved-icon' },
    { label: 'Completed', key: 'completed', value: 0, icon: ResultIconTrendingUp, className: 'completed-icon' },
    { label: 'Total Estimated Value', key: 'totalestimatedvalue', value: 0, icon: RupeeIcon, description: "In INR", className: 'summary-icon-orange' },
];

export const INVOICE_METRICS = [
    { label: 'Total Invoiced', key: 'totalinvoiced', value: 0, icon: DollarIcon, className: 'total-icon' },
    { label: 'Paid', key: 'paid', value: 0, icon: CircleTickIcon, className: 'approved-icon' },
    { label: 'Pending', key: 'pending', value: 0, icon: ClockIcon, className: 'pending-icon' },
    { label: 'Overdue', key: 'overdue', value: 0, icon: CircleAlertIcon, className: 'warning-icon' }
];